const set_auto_overlaps = (overlapSections = null, isEditor = false) => {
  overlapSections = overlapSections || document.querySelectorAll('.page-section:where(.overlaps-top-auto, .overlaps-bottom-auto)');

  if(!overlapSections || overlapSections.length === 0) return;

  overlapSections.forEach(section => {
    const innerContentWrap = section.querySelector('.acf-innerblocks-container');
    if(!innerContentWrap) return;

    const isTopOverlap = section.classList.contains('overlaps-top');
    const isBottomOverlap = section.classList.contains('overlaps-bottom');
    
    let isLastSection = false;
    let siblingSection;

    let wpBlockWrapper, wpBlockSibling; 

    if(isEditor){
      wpBlockWrapper = section.closest('.wp-block-acf-page-section');
      wpBlockSibling = isTopOverlap ? wpBlockWrapper.previousElementSibling : wpBlockWrapper.nextElementSibling;
      
      if(wpBlockSibling){
        if(wpBlockSibling.classList.contains('wp-block-acf-page-section')) {
          siblingSection = wpBlockSibling.querySelector('.page-section');
        }
        else if(wpBlockSibling.classList.contains('wp-block-acf-hero')){
          siblingSection = wpBlockSibling.querySelector('.hero');
        }
      } 
      // console.log({
      //   'section': section,
      //   'wpBlockWrapper': wpBlockWrapper,
      //   'wpBlockSibling': wpBlockSibling,
      //   'siblingSection': siblingSection,
      //   'isTopOverlap': isTopOverlap,
      //   'isBottomOverlap': isBottomOverlap,
      // });

      if(!siblingSection) return;
    }
    else {
      isLastSection = !section.nextElementSibling || !section.nextElementSibling.classList.contains('page-section');
      siblingSection = isTopOverlap ? section.previousElementSibling : (isBottomOverlap && !isLastSection ? section.nextElementSibling : null);
      
      if(isBottomOverlap && isLastSection) {
        siblingSection = document.querySelector('.site-footer');
      }

      if(!siblingSection || !(siblingSection.classList.contains('hero') || siblingSection.classList.contains('page-section') || siblingSection.classList.contains('site-footer'))) return;
    }
    
    // const measurementElement = isTopOverlap ? innerContentWrap.firstElementChild : innerContentWrap.lastElementChild;
    let measurementElement;
    if(isTopOverlap) {
      measurementElement = innerContentWrap.firstElementChild;
    }
    else if(isBottomOverlap) {
      measurementElement = [...innerContentWrap.children]
        .filter(el => !el.classList.contains('block-list-appender'))
        .pop();
    }
    let measurementElementHeight = measurementElement ? measurementElement.offsetHeight : 0;
    
    // If the first element is a .sizing-container, .grid-container, or .flex-container, 
    // select the first element within that.
    // if(measurementElement && measurementElement.classList.contains('sizing-container') || measurementElement.classList.contains('grid-container') || measurementElement.classList.contains('flex-container')) {
    //   const innerWrapper = measurementElement.firstElementChild;
    //   measurementElement = isTopOverlap ? innerWrapper.firstElementChild : innerWrapper.lastElementChild;
    // }
    
    if (measurementElement) {
      const setHalfOverlap = () => {
        // console.log('Setting overlap for section:', section);
        // console.log({
        //   'section': section,
        //   'wpBlockWrapper': wpBlockWrapper || null,
        //   'wpBlockSibling': wpBlockSibling || null,
        //   'siblingSection': siblingSection || null,
        //   'isTopOverlap': isTopOverlap,
        //   'isBottomOverlap': isBottomOverlap,
        //   'measurementElement': measurementElement,
        //   'measurementElementHeight': measurementElement.offsetHeight,
        // });
        measurementElementHeight = measurementElement.offsetHeight;
        const overlapValue = measurementElementHeight / 2;
        const sectionPropName = isTopOverlap ? '--overlap-distance-top-auto' : '--overlap-distance-bottom-auto';
        const siblingPropName = isTopOverlap ? '--overlap-padding-bottom-auto' : '--overlap-padding-top-auto';
        section.style.setProperty(sectionPropName, `${overlapValue}px`);
        siblingSection.style.setProperty(siblingPropName, `${overlapValue}px`);
      };

      if(isEditor) {
        setTimeout(() => {
          setHalfOverlap();
        }, 100); // Delay to ensure accurate measurements after any potential layout shifts
      }
      else {
        setHalfOverlap();
      }

      let debouncer;
      window.addEventListener('resize', () => {
        if (debouncer) {
          clearTimeout(debouncer);
        }
        debouncer = setTimeout(setHalfOverlap, 100);
      });

      // If is editor, set a MutationObserver to watch for changes in the measurement element that might affect its height (like adding/removing blocks inside it)
      if(isEditor) {
        const observer = new MutationObserver(() => {
          const currentMeasurementHeight = measurementElement.offsetHeight;
          if(currentMeasurementHeight !== measurementElementHeight) {
            setHalfOverlap();
          }
        });

        observer.observe(measurementElement, { childList: true, subtree: true, attributes: true });
      }
    }
  });
}

export const InitSectionSplits = () => {
  const overlapSections = document.querySelectorAll('.page-section:where(.overlaps-top-auto, .overlaps-bottom-auto)');
  if(overlapSections.length === 0) return;
  set_auto_overlaps(overlapSections);
}


export const InitSectionSplitsEditor = () => {
  if( window.acf ) {
    window.acf.addAction( 'render_block_preview/type=page-section', ( $block ) => {
      const section = $block[0].querySelector('.page-section:is(.overlaps-top, .overlaps-bottom)');
      if(!section) return;
      set_auto_overlaps( [section], true );
    });
  }
}